<div class="reset-password-page">

  <!-- Decorative scattered elements -->
  <img class="deco deco--top-left"     src="assets/sketches/1.png" alt="" aria-hidden="true" />
  <img class="deco deco--top-right"    src="assets/sketches/6.png" alt="" aria-hidden="true" />
  <img class="deco deco--heart"        src="assets/sketches/4.png" alt="" aria-hidden="true" />
  <img class="deco deco--plant"        src="assets/sketches/3.png" alt="" aria-hidden="true" />
  <img class="deco deco--bottom-right" src="assets/sketches/5.png" alt="" aria-hidden="true" />

  <!-- Main two-column layout -->
  <div class="page-content">

    <!-- Left: illustration -->
    <div class="illustration-col">
      <img class="doctor-img" src="assets/sketches/female-doc-forgot-password.png" alt="Doctor with key" />
    </div>

    <!-- Right: form -->
    <div class="form-col">
      <h1 class="welcome-title" *ngIf="!errors.length">{{ 'auth.resetPassword.title' | translate }}</h1>
      <p class="welcome-sub" *ngIf="!errors.length">{{ 'auth.resetPassword.subtitle' | translate }}</p>

      <!-- Alerts -->
      <div class="alertWrapper">
        <nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
          <p class="alert-title" style="text-align: center;"><b>{{ 'auth.resetPassword.errorTitle' | translate }}</b></p>
          <div class="alert-message-list" style="text-align: center;">
            <span *ngFor="let error of errors" class="alert-message">{{ error }}</span>
          </div>
          <button nbButton fullWidth status="primary" size="large" routerLink="/forgot-password" style="margin-top: 1rem;">
            {{ 'auth.resetPassword.requestNewLink' | translate }}
          </button>
        </nb-alert>

        <nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert" style="word-wrap: break-word">
          <p class="alert-title"><b>{{ 'auth.resetPassword.successTitle' | translate }}</b></p>
          <ul class="alert-message-list">
            <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
          </ul>
        </nb-alert>
      </div>

      <!-- Password Form -->
      <div *ngIf="!errors.length && !messages.length"
           [nbSpinner]="submitted"
           nbSpinnerStatus="primary"
           nbSpinnerSize="giant"
           nbSpinnerMessage="">
        <app-password-set
          submitButtonText="Reset Password"
          [disabled]="submitted"
          (passwordSubmit)="resetPass($event)">
        </app-password-set>

        <section class="sign-in-or-up" aria-label="Sign in">
          <p><a class="text-link" routerLink="/userLogin">{{ 'auth.resetPassword.backToLogin' | translate }}</a></p>
        </section>
      </div>
    </div>

  </div>
</div>
